import { defineMessages } from 'react-intl'

export default defineMessages({
    updateSuccess: {
        id: 'frontend.app.containers.AuditionScopePage.components.SubmittedTable.components.SubmittedTableCommentModel.updateSuccess',
        defaultMessage: 'Successfully updated comment',
    },
    modalTitle: {
        id: 'frontend.app.containers.AuditionScopePage.components.SubmittedTable.components.SubmittedTableCommentModel.modalTitle',
        defaultMessage: 'Comment',
    },
    internalComment: {
        id: 'frontend.app.containers.AuditionScopePage.components.SubmittedTable.components.SubmittedTableCommentModel.internalComment',
        defaultMessage: 'Internal comment',
    },
    externalComment: {
        id: 'frontend.app.containers.AuditionScopePage.components.SubmittedTable.components.SubmittedTableCommentModel.externalComment',
        defaultMessage: 'External comment',
    },
    externalCommentDescription: {
        id: 'frontend.app.containers.AuditionScopePage.components.SubmittedTable.components.SubmittedTableCommentModel.externalCommentDescription',
        defaultMessage: 'This comment is visible for the client',
    },
    loading: {
        id: 'frontend.app.containers.AuditionScopePage.components.SubmittedTable.components.SubmittedTableCommentModel.loading',
        defaultMessage: 'Loading',
    },
    update: {
        id: 'frontend.app.containers.AuditionScopePage.components.SubmittedTable.components.SubmittedTableCommentModel.update',
        defaultMessage: 'Update',
    },
    close: {
        id: 'frontend.app.containers.AuditionScopePage.components.SubmittedTable.components.SubmittedTableCommentModel.close',
        defaultMessage: 'Close',
    },
    copy: {
        id: 'frontend.app.containers.AuditionScopePage.components.SubmittedTable.components.SubmittedTableCommentModel.copy',
        defaultMessage: 'Copy internal message to external message',
    }
})
